import './FAQAccordion.scss';

interface IFaqItem {
    id?: string;
    question: string;
    answer: JSX.Element | null;
}

export const FAQAccordion = ({ items }: { items: IFaqItem[] }) => (
    <div className="faq-accordion">
        {items.map((faq: IFaqItem, index: number) => (
            <details key={index}>
                <summary>{faq.question}</summary>
                <section>{faq.answer}</section>
            </details>
        ))}
    </div>
);
